import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { getErrorHandlingOptions } from '../base/headers';
import { NonProductiveManufacturingOrder } from '../../models/non-productive-manufacturing-order';
import { NonProductiveManufacturingOrderBuilder } from '../../models/builders/non-productive-manufacturing-order.builder';

const nonProductiveManufacturingOrderBody = (nonProductiveManufacturingOrder: NonProductiveManufacturingOrder) => ({
  code: nonProductiveManufacturingOrder.code,
  projectNumber: nonProductiveManufacturingOrder.projectNumber,
  description: nonProductiveManufacturingOrder.description,
  category: nonProductiveManufacturingOrder.categoryHash
});

@Injectable()
export class NonProductiveManufacturingOrderApiService {
  private apiUrl: string;

  constructor(private httpClient: HttpClient) {
    this.apiUrl = `${ environment.apiUrl }non-productive-manufacturing-orders`;
  }

  getNonProductiveManufacturingOrders() {
    return this.httpClient.get(`${ this.apiUrl }`, getErrorHandlingOptions())
      .pipe(
        map(NonProductiveManufacturingOrderBuilder.fromList)
      );
  }

  getNonProductiveManufacturingOrder(hash: string) {
    return this.httpClient.get(`${ this.apiUrl }/${ hash }`)
      .pipe(
        map(NonProductiveManufacturingOrderBuilder.fromJson)
      );
  }

  createNonProductiveManufacturingOrder(nonProductiveManufacturingOrder) {
    const body = nonProductiveManufacturingOrderBody(nonProductiveManufacturingOrder);
    return this.httpClient.post(this.apiUrl, body).pipe(map(NonProductiveManufacturingOrderBuilder.fromJson));
  }

  updateNonProductiveManufacturingOrder(nonProductiveManufacturingOrder: NonProductiveManufacturingOrder) {
    return this.httpClient.put(
      `${ this.apiUrl }/${ nonProductiveManufacturingOrder.hash }`,
      nonProductiveManufacturingOrderBody(nonProductiveManufacturingOrder)
    );
  }

  deleteNonProductiveManufacturingOrder(nonProductiveManufacturingOrder: NonProductiveManufacturingOrder) {
    return this.httpClient.delete(`${ this.apiUrl }/${ nonProductiveManufacturingOrder.hash }`);
  }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/services/api/non-productive-manufacturing-order-api.service.ts